import { router } from "expo-router";
import i18next from "./lib/i18n";

const safeParseJson = (data: unknown) => {
	if (typeof data === "string") {
		return JSON.parse(data);
	}
	return data;
};

export const handleNavigateBack = (parentRoute: string) => {
	if (router.canGoBack()) {
		router.back();
	} else {
		router.replace(parentRoute as never);
	}
};

export const isI18nKeyExists = (key: string) => {
	return i18next.exists(key);
};

export const calculateAccuracy = ({
	numCorrect,
	numTotal,
}: {
	numCorrect: number;
	numTotal: number;
}) => {
	return Math.round((numCorrect / numTotal) * 100);
};

export default safeParseJson;
